import { render, staticRenderFns } from "./ResourceChart.vue?vue&type=template&id=f0d8f22c"
import script from "./ResourceChart.vue?vue&type=script&lang=js"
export * from "./ResourceChart.vue?vue&type=script&lang=js"
import style0 from "./ResourceChart.vue?vue&type=style&index=0&id=f0d8f22c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports